import { CellTable } from "@/atoms"
import { ICONS_INSIGHTS } from "@/const/insights-constants"
import { getDefaultColumnParams } from "@/helpers/table.helpers"
import { HasFix } from "@/icons"
import { FixInsightsCell } from "@/molecules/FixInsightsCell"
import { ImpactCell } from "@/molecules/ImpactCell"
import { IssueTitleCell } from "@/molecules/IssueTitleCell"
import { KodemScoreIssueCell } from "@/molecules/KodemScoreCell"
import { TriageIssueActionCell } from "@/molecules/TriageActionCell"
import { InsightsTriageCell } from "../../molecules/InsightsTriageCell"
import { renderIssueTakenActions } from "../../molecules/TakenActionsCell"

import type { Issue } from "@/domain/issue"
import type { RowClick } from "@/hooks/useLinkDrawerTooltip"
import type { TFunction } from "@/hooks/useTranslation"
import type { Item } from "@/molecules/InsightsIcons"

// The demo shows the same flag as everyone else, only worded differently.
const DEMO_REMEDIATION_ITEM: Item = {
  ...ICONS_INSIGHTS.hasKodemRemediation,
  labelKey: "availableRemediations",
  Icon: HasFix
}

interface Props {
  t: TFunction
  internetFacingFF: boolean
  onRowClick: RowClick
  setRecord: (record: Issue) => void
  isDemo?: boolean
}

export const getColumnsExpandedRow = ({
  t,
  internetFacingFF,
  onRowClick,
  setRecord,
  isDemo
}: Props) => [
  {
    title: null,
    render: IssueTitleCell({ t, setRecord }),
    ...getDefaultColumnParams("cve")
  },
  {
    width: 135,
    className: "center-align-tab-template-component",
    render: KodemScoreIssueCell(t),
    ...getDefaultColumnParams("kodemScore")
  },
  {
    title: null,
    render: InsightsTriageCell(t, internetFacingFF, isDemo),
    width: 145,
    ...getDefaultColumnParams("riskInsights")
  },
  {
    title: null,
    render: FixInsightsCell(t, isDemo ? DEMO_REMEDIATION_ITEM : undefined),
    width: 235,
    ...getDefaultColumnParams("fixInsights")
  },
  {
    title: null,
    render: ImpactCell({ onRowClick }),
    width: 70,
    className: "center-align-tab-template-component",
    ...getDefaultColumnParams("applicationCount")
  },
  {
    title: null,
    render: isDemo ? renderIssueTakenActions : TriageIssueActionCell(t),
    width: 84,
    className: "center-align-tab-template-component",
    ...getDefaultColumnParams("tickets")
  },
  {
    title: null,
    width: 125,
    render: CellTable,
    ...getDefaultColumnParams("discoveredDaysAgo")
  }
]
